// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson
// Additional terms under AGPL section 7(b) apply — see ADDITIONAL-TERMS.md.

/** RFC 6901: `~` becomes `~0`, `/` becomes `~1`, in that order. */
export function encodePointerToken(t: string): string {
  return t.replace(/~/g, '~0').replace(/\//g, '~1');
}

export function buildPointer(path: readonly (string | number)[]): string {
  if (path.length === 0) return '';
  return '/' + path.map((p) => encodePointerToken(String(p))).join('/');
}

/**
 * A JSON pointer can itself be personal data.
 *
 * `{"customers": {"alice@example.com": {...}}}` is a real shape, and writing that pointer into
 * findings.csv would leak the email the tool exists to protect — in the very artefact people
 * paste into tickets. Object keys that match a PII rule are replaced with a marker.
 */
export function maskPointerKeys(pointer: string, isSensitive: (segment: string) => boolean): string {
  if (pointer === '' || pointer === '#raw') return pointer;
  const parts = pointer.split('/');
  for (let i = 1; i < parts.length; i++) {
    const decoded = parts[i]!.replace(/~1/g, '/').replace(/~0/g, '~');
    if (isSensitive(decoded)) parts[i] = '⟨key⟩';
  }
  return parts.join('/');
}
